import api from '../api';

function toRadian(degree) {
  return (degree * Math.PI) / 180;
}

function calcDistance(orig, dest) {
  //From stackoverflow
  //stackoverflow.com/questions/43167417/calculate-distance-between-two-points-in-leaflet
  // return distance in meters
  let lon1 = toRadian(orig.longitude),
    lat1 = toRadian(orig.latitude),
    lon2 = toRadian(dest.longitude),
    lat2 = toRadian(dest.latitude);

  let deltaLat = lat2 - lat1;
  let deltaLon = lon2 - lon1;

  let a =
    Math.pow(Math.sin(deltaLat / 2), 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2);
  let c = 2 * Math.asin(Math.sqrt(a));
  let EARTH_RADIUS = 6371;

  return c * EARTH_RADIUS * 1000;
}

async function fetchBrowserGeo() {
  if (navigator.geolocation) {
    let { coords } = await new Promise((res, rej) => {
      navigator.geolocation.getCurrentPosition(res, rej);
    });

    let { data } = await api.get('geoReverse', {
      params: {
        latitude: coords.latitude,
        longitude: coords.longitude,
      },
    });

    return data;
  } else {
    throw Error('Geolocation not supported!');
  }
}

const getMarkerTemplate = (
  { order, logo, products, from },
  dots = false,
  partial = null
) => {
  if (dots || !order?.online_total) {
    return dots ? '' : logo;
  }

  return `<div class="mark">
      <div class="mark__logo">
        ${logo}
      </div>
      <div class="mark__content">
          <div class="mark__price">${
            order?.online_total ? `${order?.online_total?.toString()} ₴` : ''
          }
          ${partial ? `<div class="mark__footnote">*</div>` : ''}
        </div>
        <div class="mark__goods">
          ${products} ${from} ${order?.completeness?.total}
        </div>
      </div>
    </div>`;
};

const getIconSize = (order, dots = false) => {
  let iconSize = [40 + order?.online_total.toString().length * 15, 32];

  return dots || !order?.online_total ? (dots ? [10, 10] : [30, 30]) : iconSize;
};

const renderLogo = (image, isTab, alt = '') =>
  `<img src=${
    image
      ? encodeURI(`${image}?w=${isTab ? 58 : 24}`)
      : '/assets/images/partner.png'
  } alt=${alt} class="marker__logo" />`;

export {
  calcDistance,
  fetchBrowserGeo,
  getIconSize,
  getMarkerTemplate,
  renderLogo,
};
